import React, { useMemo } from 'react'
import {
	ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts'
import { SINGLE_RESPONSIVE_CONTAINER_MIN_SIZE } from '../../constants/constants';
import { useAppSelector } from '../../store/hooks/hooks';

const TICKS_COUNT = 5;

const getTicks = (min: number, max: number) =>
	Array.from({ length: TICKS_COUNT }, (_, i) => min + (max - min) * i / (TICKS_COUNT - 1));

const InteractiveChart: React.FC = () => {
	const resultTable = useAppSelector(state => state.materialBalance.resultTable);

	const points = useMemo(
		() => Object.values(resultTable).map(row => ({ g: Number(row.g), pz: Number(row.pz) })),
		[resultTable]
	);
	const isEmpty = points.length === 0;

	const { minX, maxX, minY, maxY } = useMemo(() => {
		if (isEmpty) {
			return { minX: 0, maxX: 100, minY: 0, maxY: 25 };
		}
		const xs = points.map(point => point.g);
		const ys = points.map(point => point.pz);
		return { minX: Math.min(...xs), maxX: Math.max(...xs), minY: Math.min(...ys), maxY: Math.max(...ys) };
	}, [points, isEmpty]);

	return (
		<div className="material-balance__interactive-chart round-corner-container">
			<ResponsiveContainer width="100%" height={300} {...SINGLE_RESPONSIVE_CONTAINER_MIN_SIZE}>
				<ScatterChart margin={{ top: 20, right: 30, left: 30, bottom: 40 }}>
					<CartesianGrid strokeDasharray="0" horizontal={true} vertical={true} />
					<XAxis
						axisLine={true}
						dataKey="g"
						name="Gp"
						domain={[minX, maxX]}
						label={{ value: "Gp", position: 'insideBottom', offset: -10 }}
						type="number"
						ticks={getTicks(minX, maxX)}
						tickFormatter={(value: number) => value.toFixed(0)}
					/>
					<YAxis
						axisLine={true}
						dataKey="pz"
						name="P/z"
						domain={[minY, maxY]}
						label={{ value: "P/z", angle: -90, position: 'insideLeft', offset: -17 }}
						type="number"
						ticks={getTicks(minY, maxY)}
						tickFormatter={(value: number) => value.toFixed(1)}
					/>
					<Tooltip
						cursor={{ strokeDasharray: '3 3' }}
						wrapperStyle={{ pointerEvents: 'none' }}
						isAnimationActive={false}
					/>
					<Scatter
						data={points}
						fill="#4c23deff"
						isAnimationActive={false}
					/>
				</ScatterChart>
			</ResponsiveContainer>
		</div >
	)
}

export default React.memo(InteractiveChart)